export default __webpack_public_path__ + "static/media/remote-bottom.ca966dc7.png";